export default function translate(i18n, propriete) {
  if (propriete === 'domiciliationBancaireId') return i18n.t('remiseBancaire.ajoutRemise.banque');
  if (propriete === 'modeReglementId') return i18n.t('remiseBancaire.ajoutRemise.modeReglement');
  if (propriete === 'dateRemise') return i18n.t('remiseBancaire.ajoutRemise.dateRemise');
  if (propriete === 'dateComptable') {
    return i18n.t('annulerReglement.dateComptable');
  }
  return propriete;
}
